<script>
import moment from 'moment'
import 'moment/locale/th';
var md5 = require('md5');

var checkMobile = (navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i)) || false;

import Swal from 'sweetalert2';
import { secret } from './repository.js';

export default {
  data() {
    return {
      needPassword: false,
      tokenPassword: "",
      loading_screen: true,
      checkMobile: checkMobile,
    }
  },
  // created(){
  //   ...
  // },
  methods: {
    LocalStorage(name, set = new Object()) {
      var taskArrayString = localStorage.getItem(name);
      if (taskArrayString !== null && typeof taskArrayString === "string") {
        // console.log("Succesfully retrieved 'tasks' and contents.");
      } else {
        // console.log("Succesfully retrieved 'tasks', contents were not a string or held no contents. Contents of 'tasks' reset to empty object");
        var emptyArray = JSON.stringify(set);
        localStorage.setItem(name, emptyArray);
        taskArrayString = localStorage.getItem(name);
      }
      return JSON.parse(taskArrayString);
    },
    alphabetically(array, field) {
      return array.sort(function (a, b) {
        if (a[field] < b[field]) { return -1; }
        if (a[field] > b[field]) { return 1; }
        return 0;
      })
    },
    sort_by_text_length(array) {
      return array.sort((a, b) => a.length - b.length);
    },
    set_session_userData(data) {
      let acc = {
        id: data.id,
        username: data.username,
        password: data.password,
        fname: data.fname,
        lname: data.lname,
        img: data.img,
        token: data.token
      }
      localStorage.setItem("_userData_", JSON.stringify(acc));
    },
    calculateExperience(startYear, startMonth) {
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth() + 1; // Months are zero-based

      let yearsDiff = currentYear - startYear;
      let monthsDiff = currentMonth - startMonth;

      if (monthsDiff < 0) {
        yearsDiff--;
      }

      return yearsDiff;
    },
    check_login() {
      setTimeout(() => this.loading_screen = false, 1000);
      // if(account.m_id){
      //   setTimeout(()=> this.loading_screen = false, 1000);
      //   return true;
      // }else{
      //   this.redirect("/");
      // }
    },
    md5(val) {
      return md5(val);
    },
    redirect(path, obj = null) {
      if (this.$route.path !== path) {
        if (obj) {
          this.$router.push({ path: path, query: obj });
        } else {
          this.$router.push(path)
        }
      } else if (path == "/search" || path == "/videos/search") {
        if (obj) {
          this.$router.push({ path: path, query: obj });
        } else {
          this.$router.push(path)
        }
      }
    },
    removeQueryString() {
      const newUrl = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, newUrl);
    },
    login_with_token() {
      let tokenData = this.LocalStorage("_tokenData_");
      // let memberData = this.LocalStorage("_memberData_");
      // let accountData = this.LocalStorage("_accountData_");
      // console.log( tokenData );
      // console.log( memberData, accountData );
      if (tokenData.email && tokenData.token && tokenData.type) {
        this.login_token(tokenData);
      }
    },
    resetURLParam() {
      let url = new URL(window.location.href);
      // url.split('?')[0];
      location.replace(`${url}`);
    },
    setURLParam(topic = 0, sub = 0, content = 0) {
      let url = new URL(window.location.href);

      url = url.href.includes("?") ? url.href.split('?')[0] : url;

      if (parseInt(topic)) url += `?topic=${topic}`;
      if (parseInt(sub)) url += `&sub=${sub}`;
      if (parseInt(content)) url += `&content=${content}`;

      // alert(url);
      location.replace(`${url}`);
    },
    async login_token(tokenData) {
      // console.log(tokenData);

      var url = this.api + 'login/token/' + this.secret;
      var data = new FormData();
      data.set('email', tokenData.email);
      data.set('token', tokenData.token);
      data.set('type', tokenData.type);
      await this.Axios.post(url, data)
        .then((response) => {
          // console.log(response.data);
          if (response.data.error == 0) {
            let acc = response.data.data;
            this.save_token(acc);
            switch (tokenData.type) {
              case "personal_account":
                // localStorage.setItem("_accountData_",JSON.stringify(acc));
                // this.accountData = acc;
                // this.redirect("/personal");
                this.redirect("/personal/update_profile");
                break;
              case "members":
                // localStorage.setItem("_memberData_",JSON.stringify(acc));
                // this.memberData = acc;
                this.redirect("/members");
                break;
            }
            // this.$swal("Successful Login ","","success");
            this.$emit("close");
          } else {
            this.needPassword = true;
          }
        })
        .catch((error) => {
          this.$swal("", "", "warning");
          console.error(error);
        })
        .then(() => {
          this.is_loading = false;
        })
    },
    save_token(data) {
      let tokenData = new Object();
      tokenData.email = data.m_username;
      tokenData.m_img = data.m_img;
      tokenData.token = data.token;
      tokenData.type = data.type;
      localStorage.setItem("_tokenData_", JSON.stringify(tokenData));
    },
    set_data(data, array) {
      if (Array.isArray(data)) return data;

      let Val = [];
      let Data = data.split(",");
      Data.forEach((e) => {
        let index = array.findIndex(x => x.id == e);
        if (index !== -1) Val.push(array[index]);
      });
      return Val
    },
    r_com_type(company) {
      let text = company.com_type;
      if (this.com_type.length) {
        let index = this.com_type.findIndex((e) => parseInt(e.id) == parseInt(company.com_type));
        if (index > -1) return this.com_type[index].name;
      } else {
        return text;
      }
    },
    ask_for_logout() {
      this.$swal(`Are you sure you want to logout?`, ``, "warning", { buttons: ['Stay logged in', `Logout`], dangerMode: true })
        .then((ok) => {
          if (ok) {
            this.logout();
          }
        });
    },
    logout() {
      localStorage.setItem("_userData_", JSON.stringify(new Object));
      // setTimeout(() => window.location.href = '/', 1);
      setTimeout(() => window.location.reload(), 1);
    },
    uniq_id() {
      var n = Math.floor(Math.random() * 11);
      var k = Math.floor(Math.random() * 1000000);
      var m = String.fromCharCode(n) + k;
      return m;
    },
    Verified_by_MyThaiAdvisor_front() {
      this.$swal(`Verified Company Status`, `Company search listings with a blue badge indicate that MyThaiAdvisor has verified the company’s legal registration in Thailand. Our verification process includes reviewing their official company documents to ensure authenticity and reliability. Companies with this badge have been recognized as established and legitimate businesses within our network.`, "/assets/verify.png")
    },
    Verified_by_MyThaiAdvisor() {
      Swal.fire({
        title: "This Company has been Verified by MyThaiAdvisor.",
        iconHtml: `<img src="/assets/verify.png">`,
        showConfirmButton: false,
        timer: 4000,
        toast: true,
        position: 'top-end',
        customClass: {
          popup: 'verified-company-popup',
        },
      });
    },
    generateRandomNumber() {
      // Generate a random 6-digit number
      const min = 100000; // Minimum 6-digit number
      const max = 999999; // Maximum 6-digit number
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];  // ES6 destructuring swap
      }
    },
    removeDoubleSpace(text) {
      try {
        // Replace multiple consecutive <p><br></p> with a single one
        return text.replace(/(<p><br><\/p>\s*){2,}/g, '<p><br></p>');
      } catch {
        return text;
      }
    },
    setTooltipDelay() {
      const tooltipElements = this.$el.querySelectorAll('[data-tooltip-delay]');

      tooltipElements.forEach(el => {
        let delayTimer;

        el.addEventListener('mouseenter', () => {
          delayTimer = setTimeout(() => {
            // Set the tooltip content dynamically
            el.setAttribute('data-tooltip', el.getAttribute('data-tooltip-delay'));
            el.classList.add('has-tooltip-active');
          }, 400); // delay in milliseconds
        });

        el.addEventListener('mouseleave', () => {
          clearTimeout(delayTimer);
          el.classList.remove('has-tooltip-active');
          el.removeAttribute('data-tooltip'); // Clean up to prevent instant re-trigger
        });
      });
    },
    getDicebearAvatar(firstName, lastName) {
      const first = firstName || '';
      const last = lastName || '';
      const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();

      return `https://api.dicebear.com/7.x/initials/svg?seed=${initials}`;
    },
  },
  filters: {
    // moment(date) {
    //   return moment(date).format('Do MMMM YYYY');
    // },
    // date_message: function (date) {
    //   return moment(date).format('D MMM, YYYY h:mm a');
    // },
    // date_project: function (date) {
    //   return moment(date).format('MMMM Do, YYYY h:mm a')+" (PST)";
    // },
    date_list: function (date, locale = 'en') {
      const m = moment(date).locale(locale);
      const fromNow = m.fromNow();

      return m.calendar(null, locale === 'th'
        ? {
          lastWeek: '[วัน]ddddที่แล้ว',
          lastDay: '[เมื่อวานนี้]',
          sameDay: '[วันนี้]',
          nextDay: '[พรุ่งนี้]',
          nextWeek: 'dddd',
          sameElse: function () {
            return "[" + fromNow + "]";
          }
        }
        : {
          lastWeek: '[Last] dddd',
          lastDay: '[Yesterday]',
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: 'dddd',
          sameElse: function () {
            return "[" + fromNow + "]";
          }
        }
      );
    },
    jobs_list(date, locale = 'en') {
      if (!date) return '';

      const now = moment();
      const inputDate = moment(date);

      const translations = {
        en: {
          expired: 'Expired'
        },
        th: {
          expired: 'หมดอายุ'
        }
      };

      const t = translations[locale] || translations['en'];

      if (inputDate.isBefore(now, 'day')) {
        return t.expired;
      }

      const daysDiff = inputDate.diff(now, 'days');
      const duration = moment.duration(daysDiff, 'days');
      const humanized = duration.locale(locale).humanize(true); // ✅ add `true`

      return humanized;
    },
    member_since(date, locale = 'en') {
      return moment(date).locale(locale).format('D/MM/YYYY');
    },
    member_since2(date, locale = 'en') {
      return moment(date).locale(locale).format('MMMM Do, YYYY');
    },
    member_since3(date, locale = 'en') {
      return moment(date).locale(locale).format('D MMM YYYY');
    },
    member_since4(date) {
      return moment(date).format('h:mm a');
    },
    member_since5(date, locale = 'en') {
      const s = ["ᵗʰ", "ˢᵗ", "ⁿᵈ", "ʳᵈ"];
      const momentDate = moment(date).locale(locale);
      const day = momentDate.date();
      const v = day % 100;
      const suffix = s[(v - 20) % 10] || s[v] || s[0];
      return `${day}${suffix} ${momentDate.format('MMMM YYYY')}`;
    },
    member_since6(date, locale = 'en') {
      return moment(date).locale(locale).format('h:mma');
    },
    utc_dmy(date, locale = 'en') {
      return moment.utc(date).locale(locale).format('D MMMM YYYY');
    },
    utc_hma(date, locale = 'en') {
      return moment.utc(date).locale(locale).format('h:mm a');
    },
    utc_hhm(date, locale = 'en') {
      return moment.utc(date).locale(locale).format('hh:mm');
    },
    utc_date_list(date) {
      const momentDate = moment(date); // Parse the date as local time
      const now = moment(); // Current local time

      // Check the relative day
      const isToday = momentDate.isSame(now, 'day');
      const isTomorrow = momentDate.isSame(now.clone().add(1, 'day'), 'day');
      const isYesterday = momentDate.isSame(now.clone().subtract(1, 'day'), 'day');

      if (isToday) {
        return "Today";
      } else if (isTomorrow) {
        return "Tomorrow";
      } else if (isYesterday) {
        return "Yesterday";
      } else if (momentDate.isSame(now, 'week')) {
        return momentDate.format('dddd'); // Same week
      } else {
        return momentDate.format('D MMM YYYY'); // Default date format
      }
    },
    highlight: function (words, query) {
      return words.replace(query, '<span class="highlight">' + query + '</span>')
    }
  },
  computed: {
    headersData() {
      // console.log("Current userData:", this.userData); // Debugging output

      let sessionInfo = {
        id: this.uniq_id(),
        token: this.uniq_id(),
        role: "website",
      };

      if (this.userData) {
        sessionInfo.userData = {
          googleId: this.userData.googleId,
          email: this.userData.email,
          name: this.userData.name
        };
      }

      let h = {
        secret: secret,
        session: JSON.stringify(sessionInfo)
      };

      return h;
    }
  },
  watch: {
    userData(val) {
      console.log(val)
    }
  }
};
</script>

<style>
.swal-icon--custom {
  width: 75px !important;
}

.verified-company-popup .swal2-icon {
  border: 0px !important;
  margin: 0px !important;
  width: 45px !important;
}
</style>